import { render, staticRenderFns } from "./SurfaceDesignPrintPlacements.vue?vue&type=template&id=53c5ad49"
import script from "./SurfaceDesignPrintPlacements.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignPrintPlacements.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignPrintPlacements.vue?vue&type=style&index=0&id=53c5ad49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports